import { Component, ReactNode } from 'react';

export type BraxUncontrolledFieldProps = {
    id?: string,
    children: (props: { id: string }) => ReactNode
};

export class BraxUncontrolledField extends Component<BraxUncontrolledFieldProps> {

    static counter = 0;

    counter = BraxUncontrolledField.counter++;

    render() {
        return this.props.children({
            id: this.props.id || `brax-field-control-${this.counter}`
        });
    }

}
